// src/components/TeralehtiWordPeek.js
// Hover card for a Terälehti candidate word: frequency and flags from the word list,
// definition from Asiasanasto's /api/word-preview (needs CORS enabled on that route).
import React, { useEffect, useState } from 'react';
import { fetchPreview } from '../services/wordInfoService';

// Meaning of a word from Asiasanasto; shared by the hover card and the touch sheet.
export const PeekBody = ({ word }) => {
  const [preview, setPreview] = useState(undefined);

  useEffect(() => {
    let active = true;
    setPreview(undefined);
    fetchPreview(word).then(p => { if (active) setPreview(p); });
    return () => { active = false; };
  }, [word]);

  if (preview === undefined) return <p className="tl-peek-muted">Ladataan…</p>;
  if (preview?.error) return <p className="tl-peek-muted">Asiasanasto ei vastaa ({preview.error})</p>;
  if (!preview) return <p className="tl-peek-muted">Ei Asiasanastossa</p>;
  const glosses = preview.glossesFi || preview.glossesEn;
  return (
    <>
      {preview.pos && <p className="tl-peek-muted">{preview.pos}</p>}
      {glosses
        ? <ol>{glosses.slice(0, 3).map(g => <li key={g}>{g}</li>)}</ol>
        : preview.synonyms
          ? <p>Synonyymit: {preview.synonyms.join(', ')}</p>
          : <p className="tl-peek-muted">Ei määritelmää</p>}
    </>
  );
};

const TeralehtiWordPeek = ({ entry, rect, meta }) => {
  // Below the word, flipped above it near the bottom of the viewport.
  const below = rect.bottom + 180 < window.innerHeight;
  const style = {
    left: Math.min(rect.left, window.innerWidth - 336),
    ...(below ? { top: rect.bottom + 6 } : { bottom: window.innerHeight - rect.top + 6 }),
  };

  return (
    <div className="tl-peek" style={style} role="tooltip">
      <div className="tl-peek-head">
        <strong>{entry.word}</strong>
        <span>{meta}</span>
      </div>
      <PeekBody word={entry.word} />
    </div>
  );
};

export default TeralehtiWordPeek;
